<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Bill of Lading</b-navbar-brand>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="
            this.finalPlaceUSNONUS[0].allModuleId
              ? this.finalPlaceUSNONUS[0].allModuleId
              : ''
          "
          :jobSeriesBanner="
            this.finalPlaceUSNONUS[0].ffExportFclConsoSeries
              ? this.finalPlaceUSNONUS[0].ffExportFclConsoSeries
              : ''
          "
          :bannerClientName="this.clientName ? this.clientName : ''"
          :trackingId="trackingId != '' ? trackingId : ''"
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <div class="box" v-if="conBLtable.length > 0">
              <div class="box-header">
                <label class="box-title">
                  <u>Client Container Details</u>
                </label>
                <Filter-Agency-Modal />
                <FilterCBModal />
                <ClientCard />
                 <ShipmentTrackCard />
                  <b-button
                             v-if="consobillLandingModel.blType == 'LinerBL'"
                             @click="sendMANIFESTATION"
                             size="sm"
                             variant="warning"
                             style="margin-left: 5px"
                           >SEND MANIFESTATION DETAILS</b-button>
                         
              </div>
              <b-row class="mb-5">
                <md-layout md-flex="50" class="pl-2 pr-2">
                  <label>MBL Release Date</label><br />
                  <md-layout md-flex="100">
                    <date-picker
                      :style="{ width: '500px' }"
                      :format="selectDateFormat"
                      lang="en"
                      name="mbl_release_date"
                      id="mbl_release_date"
                      class="mt-2"
                      v-model="billLandingModel.mbl_release_date"
                    ></date-picker>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="50" class="pl-2 pr-2">
                  <label>MBL Date</label><br />
                  <md-layout md-flex="100">
                    <date-picker
                      :style="{ width: '500px' }"
                      :format="selectDateFormat"
                      lang="en"
                      name="mbl_date"
                      id="mbl_date"
                      class="mt-2"
                      v-model="billLandingModel.mbl_date"
                    ></date-picker>
                  </md-layout>
                </md-layout>
              </b-row>

              <!-- /.box-header -->
              <div class="box-body">
                <table id="clientSB" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>Client Name</th>
                      <th>Container No.</th>
                      <th>Container Type</th>
                      <th>Shipping Bill No.</th>
                      <th>Shipping Bill Date</th>
                      <th>Custom Seal No</th>
                      <th>Line Seal No</th>

                      <!-- <th>Item Number</th> -->
                      <!-- <th>Edit</th>
                      <th>Delete</th>-->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in conBLtable" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.clientName }}</td>
                      <td>{{ item.fclConcontainerNo }}</td>
                      <td>{{ item.containerType }}</td>
                      <td>{{ item.SBNo }}</td>
                      <td>
                        <span v-for="(itemDate, index) in item.SBDate" :key="index"
                          >{{ itemDate | moment }}
                          {{
                            index != Object.keys(item.SBDate).length - 1 ? "," : ""
                          }}</span
                        >
                      </td>
                      <td>{{ item.customSealNo }}</td>
                      <td>{{ item.lineSealNo }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.box-body -->
            </div>

            <div
              v-if="clientList.length > 0 || consobillLandingModel.conblLandingId != ''"
            >
              <hr class="hr-border" />
              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <label
                    for="fclConsoMultipleClientId"
                    v-if="consobillLandingModel.conblLandingId == ''"
                    >Client Name</label
                  >
                  <model-list-select
                    v-if="consobillLandingModel.conblLandingId == ''"
                    :list="clientList"
                    id="fclConsoMultipleClientId"
                    v-model="consobillLandingModel.fclConsoMultipleClientId"
                    option-value="fclConsoMultipleClientId"
                    option-text="clientName"
                    placeholder="Select  Client Name"
                  ></model-list-select>
                  <md-layout md-flex="100" v-else>
                    <label for="fclConsoMultipleClientId">Client Name</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      v-model="consobillLandingModel.clientName"
                      disabled
                    ></b-form-input>
                  </md-layout>
                  <span
                    class="error"
                    v-if="!consobillLandingModel.fclConsoMultipleClientId"
                    >{{ errorVgmList.fclConsoMultipleClientId }}</span
                  >
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="25">
                  <label for="blType">B/L Type</label>
                  <model-list-select
                    :list="blTypeList"
                    v-model="consobillLandingModel.blType"
                    option-value="blTypeVal"
                    option-text="blTypeTxt"
                    placeholder="Select B/L Type"
                    :isDisabled="
                    $sessionsStorage.get('nameUser') == 'Bhavneesh'?false:
                      consobillLandingModel.conblLandingId != '' ||
                      blTableArray.length > 0
                        ? true
                        : false
                    "
                  ></model-list-select>
                  <span class="error" v-if="!consobillLandingModel.blType">{{
                    errorVgmList.blType
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25" v-if="consobillLandingModel.blType == 'LinerBL'">
                  <label for="frghtTermsLiner">Liner Freght Terms</label>
                  <model-list-select
                    :list="frghtTermsLinerListName"
                    v-model="consobillLandingModel.frghtTermsLiner"
                    option-value="frghtTermsLinerVal"
                    option-text="frghtTermsLinerTxt"
                    placeholder="Select Freght Terms"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25" v-if="consobillLandingModel.blType == 'HouseBL'">
                  <label for="frghtTermsHbl">Freght Terms for HBL</label>
                  <model-list-select
                    :list="frghtTermsHblList"
                    v-model="consobillLandingModel.frghtTermsHbl"
                    option-value="frghtTermsHblVal"
                    option-text="frghtTermsHblTxt"
                    placeholder="Select Freght Terms for HBL"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25" v-if="consobillLandingModel.blType == 'HouseBL'">
                  <label for="frghtTermsMbl">Freght Terms for MBL</label>
                  <model-list-select
                    :list="frghtTermsMblList"
                    v-model="consobillLandingModel.frghtTermsMbl"
                    option-value="frghtTermsMblVal"
                    option-text="frghtTermsMblTxt"
                    placeholder="Select Freght Terms for MBL"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25" v-if="consobillLandingModel.blType == 'LinerBL'">
                  <md-layout md-flex="100">
                    <label>Master B/L Number</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="linerBLNumber"
                      name="linerBLNumber"
                      v-model="consobillLandingModel.linerBLNumber"
                      :disabled="
                        consobillLandingModel.conblLandingId != '' ||
                        blTableArray.length > 0
                          ? true
                          : false
                      "
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!consobillLandingModel.linerBLNumber">{{
                    errorlinerBLNumber
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20" v-if="consobillLandingModel.blType == 'LinerBL'">
                  <md-input-container>
                    <label>Upload Liner B/L</label>
                    <md-file
                      name="linerBLupload"
                      id="linerBLupload"
                      v-model="consobillLandingModel.linerBLupload"
                      @selected="onFileChangelinerBL"
                      :disabled="
                        consobillLandingModel.conblLandingId != '' ||
                        blTableArray.length > 0
                          ? true
                          : false
                      "
                      multiple
                    ></md-file>
                  </md-input-container>

                  <span class="error" v-if="!consobillLandingModel.linerBLupload">{{
                    errorlinerBLupload
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter v-if="uploadBookingStatus.length > 0">
                <md-layout md-flex="35"></md-layout>
                <md-layout
                  md-flex="15"
                  v-for="(item, index) in uploadBookingStatus"
                  :key="index"
                >
                  <a :href="`${this.docURL}/LinerBLCon/` + item" target="_blank" download
                    >View Document - {{ index + 1 }}</a
                  >
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="25">
                  <label for="billingParty">Billing Party</label>
                  <model-list-select
                    :list="billingPartyList"
                    v-model="consobillLandingModel.billingParty"
                    option-value="billingPartyVal"
                    option-text="billingPartyTxt"
                    placeholder="Select Billing Party"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <label for="billingParty"
                    >Billing Type : <span class="error">*</span></label
                  >
                  <b-form-radio-group
                    v-model="consobillLandingModel.billingType"
                    :options="billingTypeList"
                    class="mt-3"
                    value-field="BTVal"
                    text-field="BTText"
                    disabled-field="notEnabled"
                  ></b-form-radio-group>
                  <span class="error" v-if="!consobillLandingModel.billingType">{{
                    errorVgmList.billingType
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <!-- <md-layout md-flex="30" v-if="consobillLandingModel.billingParty=='clientName'">
              <label for="clientId">Client Name</label>
              <model-list-select
                :list="AllclientList"
                id="clientId"
                v-model="consobillLandingModel.clientId"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select  Client Name"
              ></model-list-select>
            </md-layout>

            <md-layout md-flex="30" v-if="consobillLandingModel.billingParty=='chaName'">
              <md-layout md-flex="100">
                <label>CHA Name</label>
                <b-form-input :formatter="capitalizeAll" id="chaName" name="chaName" v-model="consobillLandingModel.chaName"></b-form-input>
              </md-layout>
                </md-layout>-->
                <md-layout
                  md-flex="30"
                  v-if="consobillLandingModel.billingParty == 'OthersSpecify'"
                >
                  <md-layout md-flex="100">
                    <label>Other Specify</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="otherSpecBillingParty"
                      name="otherSpecBillingParty"
                      v-model="consobillLandingModel.otherSpecBillingParty"
                    ></b-form-input>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="20">
                  <b-button
                    size="sm"
                    style="margin-top: 40px"
                    variant="outline-info"
                    @click="addBLLanding"
                    id="addButtonLoaderCB"
                    >{{
                      consobillLandingModel.conblLandingId == "" ? "Add" : "Edit"
                    }}
                    Client BL</b-button
                  >
                  <md-spinner
                    md-indeterminate
                    id="loaderCB"
                    style="display: none"
                  ></md-spinner>
                </md-layout>
              </md-layout>
            </div>
            <hr class="hr-border" v-if="blTableArray.length > 0" />
            <div class="box" v-if="blTableArray.length > 0">
              <div class="box-header">
                <label class="box-title">
                  <u>Client BL Details</u>
                </label>
              </div>

              <!-- /.box-header -->
              <div class="box-body">
                <table id="clientBl" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>Client Name</th>
                      <th>BL Type</th>
                      <th v-if="consobillLandingModel.blType == 'LinerBL'">
                        Proceed to Invoice
                      </th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in blTableArray" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td class="showMoreData" @click="viewEditBL(item, index)">
                        {{ item.clientName }}
                      </td>
                      <td>{{ item.blType }}</td>

                      <td v-if="consobillLandingModel.blType == 'LinerBL'">
                        <md-button
                          class="md-button md-raised md-dense"
                          @click="
                            proceedToTallyByClient(
                              item.conblLandingId,
                              item.InvTallyId,
                              item.clientName
                            )
                          "
                        >
                          <!-- <md-icon>invoice</md-icon> -->
                          Invoice
                        </md-button>
                      </td>
                      <td>
                        <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="removeCommon(item)"
                        >
                          <md-icon>delete_sweep</md-icon>
                        </md-button>
                        <!-- @click="DeleteList(item)" -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.box-body  @click="proceedNewBL" -->
            </div>
            <!-- <hr class="hr-border" v-if="vgmArrayList.length>0"> -->
            <md-layout md-gutter class="mt-3" v-if="clientList.length == 0">
              <md-layout md-flex="40"></md-layout>
              <md-layout md-flex="30">
                <b-button variant="primary" @click="proceedNewBL" id="addButtonLoader1">{{
                  consobillLandingModel.blType == "LinerBL"
                    ? "Save & Proceed to AMS Filing"
                    : " Save & Proceed to BL (Draft)"
                }}</b-button>
                <md-spinner
                  md-indeterminate
                  id="loader1"
                  style="display: none"
                ></md-spinner>
                <!-- @click="()=> $router.push({ path: '/ffExportCon/conBLSlineUs' })"  -->

                <!-- <b-button
                 v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh'"
                class="ml-2"
                  variant="primary"
                   @click="proceedNewBL"
                  id="addButtonLoader1"
                >Test BL (Draft)</b-button>
                <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner> -->
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopBL"
      @close="oncloseBL"
    ></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop6"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="delete"
      @close="onCloseBLData"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
// import BannerComponent from "../allModuleForm/bannerComponent.vue";
import BannerComponent from "../allModuleForm/trackingBannerComponent.vue";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";

import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import ClientUserService from "../../services/ClientUserService.js";

export default {
  beforeMount() {
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/conFclBLofLanding");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      selectDateFormat,
      allModuleId: null,
      assignmentNo: null,
      trackingId: "",
      clientName: null,
      docURL: URL_BASE_DOC,
      isLoading: false,
      billingPartyList: [
        {
          billingPartyVal: "clientName",
          billingPartyTxt: "Client Name",
        },
        {
          billingPartyVal: "chaName",
          billingPartyTxt: "CHA Name",
        },
        {
          billingPartyVal: "OthersSpecify",
          billingPartyTxt: "Others Specify",
        },
      ],

      blTypeName: [
        {
          blTypeVal: "HouseBL",
          blTypeTxt: "House B/L",
        },
        {
          blTypeVal: "LinerBL",
          blTypeTxt: "Liner B/L",
        },
      ],
      billingTypeList: [
        {
          BTVal: "1",
          BTText: "Local",
          notEnabled: false,
        },
        {
          BTVal: "2",
          BTText: "Overseas",
          notEnabled: false,
        },
        {
          BTVal: "3",
          BTText: "Both",
          notEnabled: false,
        },
      ],
      frghtTermsHblListName: [
        {
          frghtTermsHblVal: "Prepaid",
          frghtTermsHblTxt: "Prepaid",
        },
        {
          frghtTermsHblVal: "Collect",
          frghtTermsHblTxt: "Collect",
        },
      ],
      frghtTermsMblListName: [
        {
          frghtTermsMblVal: "Prepaid",
          frghtTermsMblTxt: "Prepaid",
        },
        {
          frghtTermsMblVal: "Collect",
          frghtTermsMblTxt: "Collect",
        },
      ],
      frghtTermsLinerListName: [
        {
          frghtTermsLinerVal: "Prepaid",
          frghtTermsLinerTxt: "Prepaid",
        },
        {
          frghtTermsLinerVal: "Collect",
          frghtTermsLinerTxt: "Collect",
        },
      ],
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      excelUpload: "",
      containerTypeDetailFactory: ["rwr"],
      finalPlaceUSNONUS: [],
      BLDetailArray: ["rwr"],
      getCLientData: [],
      getAllClientDataArray: [],
      conBLtable: [],
      blTableArray: [],
      consobillLandingModel: {
        conblLandingId: "",
        billingParty: "",
        clientId: "",
        clientName: "",
        chaName: "",
        linerBLupload: "",
        linerBLNumber: "",
        otherSpecBillingParty: "",
        fclConsoMultipleClientId: "",
        blType: "",
        billingType: "",
        frghtTermsHbl: "",
        frghtTermsMbl: "",
        frghtTermsLiner: "",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        conFclBookingId: this.$sessionsStorage.get("editconFclBookingId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
        ffExecutionContainerId: "",
        finalPlaceLocationId: "",
      },
      errorlinerBLupload: "",
      errorlinerBLNumber: "",

      errorVgmList: {
        blType: "",
        fclConsoMultipleClientId: "",
        billingType: "",
      },
      arrayErrorVgm: ["Select BL Type", "Select client Id", "Select Billing Type"],

      removeVmodel: {
        weighingSlipNo: "",

        containerNo: "",
        containerTypeId: "",
        ffExecutionContainerId: "",
        ffVgmId: "",
      },
      vgmArrayList: [],
      CommodityAll: {},
      getCommodityData: ["zim"],
      ALLFclData: ["zim"],

      getContainerTypeData: ["zim"],
      validate: true,
      portCodeError: "",
      deleteId: "",
      ffExoprtDetail: {
        commodityId: "",
        IMDGClass: "",
        UNNumber: "",
        packingCode: "",
        commodityType: "",
        itemDescription: "",
      },
      billLandingModel: {
        mbl_release_date: "",
        mbl_date: "",
      },
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  watch: {
    consobillLandingModel: {
      handler: function (newVal, oldVal) {
        if (newVal.billingParty != "") {
        }
        let array = this.getCLientData.filter((x) => {
          return x.ffFclConsoExportId == newVal.ffFclConsoExportId;
        });

        if (array.length > 0) {
          this.billingPartyList[0].billingPartyTxt = "Client_" + array[0].clientName;
        }
      },
      deep: true,
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    BannerComponent,
    FilterAgencyModal,
    FilterCBModal,
    ClientCard,
    ShipmentTrackCard,
  },

  computed: {
    uploadBookingStatus() {
      return this.consobillLandingModel.linerBLupload != ""
        ? this.consobillLandingModel.linerBLupload.split(",")
        : [];
    },
    blTypeList() {
      return this.blTypeName;
    },
    clientList() {
      return this.getCLientData;
    },
    AllclientList() {
      return this.getAllClientDataArray;
    },

    frghtTermsHblList() {
      return this.frghtTermsHblListName;
    },
    frghtTermsMblList() {
      return this.frghtTermsMblListName;
    },
    frghtTermsLinerList() {
      return this.frghtTermsLinerListName;
    },

    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    commodityList() {
      return this.getCommodityData;
    },
  },

  methods: {
    sendMANIFESTATION() {
      this.$sessionsStorage.set("sendManifest_ffFclConsoallModuleId", "");
      this.$sessionsStorage.set("sendManifest_ffType", "");
      this.$sessionsStorage.set("sendManifest_ffType", "FF Con Export");
      this.$sessionsStorage.set(
        "sendManifest_ffFclConsoallModuleId",
        this.finalPlaceUSNONUS[0].allModuleId
      );
      this.$sessionsStorage.set(
        "sendManifest_ffFclConsoExportId",
        this.$sessionsStorage.get("editffFclConsoExportId")
      );
      this.$router.push({
        path: "/ffExportCon/ffconsendManifestation"
      });
    },
    removeCommon(item, index) {
      //console.log("Shreshth Gahlot=>", item); return false;
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.isDocActive = item.isBLLandingActive == "1" ? 0 : 1;
      let paylod = {
        tableName: "con_fcl_bllanding",
        tableId: "conblLandingId",
        tableIsActive: "isBLLandingActive",
        value1: this.itemObj.isDocActive,
        tableVal: item.conblLandingId,
        isMailSend: "No",
        manual: "No",
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getData();
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    proceedToTallyByClient(conblLandingId, InvTallyId, clientName) {
      this.$router.push({
        name: "FFCon invoice Linear BL",
        params: {
          conblLandingId: conblLandingId,
        },
        query: {
          allModuleId: this.finalPlaceUSNONUS[0].allModuleId,
          ffExportFclConsoSeries: this.ffExportFclConsoSeries,
          InvTallyId: InvTallyId || "",
          clientName: clientName,
        },
      });
    },
    DeleteList(item) {
      this.deleteId = item.conblLandingId;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["delete"].open();
    },
    onFileChangelinerBL() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editExportFCLId"),
        },
      };

      axios
        .post(`${URL_BASE}/Api_FFSeaExport/UploadFFBooking.php`, formData, config)
        .then((result) => {
          this.consobillLandingModel.linerBLupload = result.data;
          // console.log("fdsf", result.data);
        })
        .catch((err) => {
          throw err;
        });
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    Print(item) {
      window.open(`${URL_BASE}/vgmDetail/` + item);
    },
    onCloseBLData(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "con_fcl_bllanding",
          tableId: "conblLandingId",
          // isActive: "isBLLandingActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            // this.JqueryFun();
            this.getData();
            this.deleteId = "";
            // console.log(data);
          })
          .catch((error) => {});
      }
    },

    viewEditBL(item) {
      let arrayFilter = this.blTableArray.filter((x) => {
        return x.conblLandingId == item.conblLandingId;
      });

      this.billingPartyList[0].billingPartyTxt = "Client_" + arrayFilter[0].clientName;

      Object.keys(this.consobillLandingModel).map((x) => {
        this.consobillLandingModel[x] = arrayFilter[0][x] || "";
      });
    },
    proceedBL() {
      if (this.blTableArray[0].blType != "LinerBL") {
        if (this.finalPlaceUSNONUS[0].portLocationType != "USA") {
          this.$router.push({
            path: "/ffExportCon/conBLNonUs",
          });
        } else {
          this.$router.push({
            path: "/ffExportCon/conBLUs",
          });
        }
      } else {
        this.$sessionsStorage.set("blType", "liner");
        this.$sessionsStorage.set("ffType", "fclcon");
        this.$router.push({
          path: "/ffExportCon/conAmsFilling",
        });
      }

      this.$router.push({});
    },
    async proceedNewBL() {
      if (this.billLandingModel.mbl_date || this.billLandingModel.mbl_release_date) {
        await this.addBLDateLanding();
      }
      if (this.blTableArray[0].blType != "LinerBL") {
        if (this.finalPlaceUSNONUS[0].portLocationType != "USA") {
          this.$router.push({
            path: "/ffExportCon/conBLNewNonUs",
          });
        } else {
          this.$router.push({
            path: "/ffExportCon/conBLSlineUs",
          });
        }
      } else {
        this.$sessionsStorage.set("blType", "liner");
        this.$sessionsStorage.set("ffType", "fclcon");
        this.$router.push({
          path: "/ffExportCon/conAmsFilling",
        });
      }

      this.$router.push({});
    },
    oncloseBL() {
      //   if(this.finalPlaceUSNONUS[0].portLocationType!="USA"){
      //   this.$router.push({
      //     path:"/freightForward/BL-NonUS"
      //   });
      //   }else{
      //   this.$router.push({
      //     path:"/freightForward/BL-US"
      //   });
      //   }
    },
    getData() {
      this.doLoading();
      let new_data = {
        clientId: "clientId",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
        conFclBookingId:
          this.$sessionsStorage.get("editconFclBookingId") != "" &&
          this.$sessionsStorage.get("editconFclBookingId") != undefined
            ? this.$sessionsStorage.get("editconFclBookingId")
            : "",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/conBLLandingGetData.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            console.log(data);
            if (data.clientNamesDetails.length > 0) {
              this.getCLientData = data.clientNamesDetails;
            } else {
              this.getCLientData = [];
            }
            if (data.ffConExectionDetail.length > 0) {
              this.conBLtable = data.ffConExectionDetail;
            } else {
              this.conBLtable = [];
            }
            if (data.stuffingData.length > 0) {
              this.finalPlaceUSNONUS = data.stuffingData;
              this.billLandingModel = {
                mbl_release_date: data.stuffingData[0].mbl_release_date,
                mbl_date: data.stuffingData[0].mbl_date,
              };

              this.billingPartyList[1].billingPartyTxt =
                "CHA_" + data.stuffingData[0].ccCha;
            } else {
              this.finalPlaceUSNONUS = [];
            }

            this.conBLtable.map((x, index) => {
              this.conBLtable[index].SBDate = x.SBDate.split(",");
            });

            if (data.getAllClientData.length > 0) {
              this.getAllClientDataArray = data.getAllClientData;
            } else {
              this.getAllClientDataArray = [];
            }

            if (data.conBLData.length > 0) {
              this.blTableArray = data.conBLData;

              this.consobillLandingModel.blType = data.conBLData[0].blType;
              this.consobillLandingModel.billingType = data.conBLData[0].billingType;
              if (data.conBLData[0].blType == "LinerBL") {
                this.consobillLandingModel.linerBLupload =
                  data.conBLData[0].linerBLupload;
                this.consobillLandingModel.linerBLNumber = data.conBLData[0].blType;
              }
            } else {
              this.blTableArray = [];
              this.consobillLandingModel.blType = "";
              this.consobillLandingModel.linerBLupload = "";
              this.consobillLandingModel.linerBLNumber = "";
              this.consobillLandingModel.billingType = "";
            }

            if (
              this.consobillLandingModel.billingType &&
              this.$sessionsStorage.get("designation") != "Admin" &&
              this.$sessionsStorage.get("nameUser") != "Bhavneesh"
            ) {
              this.billingTypeList.forEach((element) => {
                element.notEnabled = true;
              });
            }
            this.getTrackingDetails();
            this.doLoadingClose();
            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },

    getTrackingDetails() {
      let new_data = {
        allModuleId: this.finalPlaceUSNONUS[0].allModuleId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Tracking/getSubscriptionTrackingDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.BIdType && data.BIdType.length > 0) {
              this.$sessionsStorage.set("trackingId", data.BIdType[0].id);
              this.trackingId = data.BIdType[0].id;
            } else {
              this.trackingId = "";
            }
          }
        })
        .catch((error) => {});
    },
    CommodityCallback(item) {
      this.ffExoprtDetail.commodityId = item.commodityId;
      this.ffExoprtDetail.commodityType = item.commodityType;
      this.ffExoprtDetail.itemDescription = item.itemDescription;
    },
    JqueryFun() {
      return $(function () {
        return $("#portLocationNew").DataTable();
      });
    },

    previousSalesView() {
      // window.history.go(-1);
      this.$router.push({
        path: "/ffExportCon/executionWHStuffingIcdCon",
      });
    },

    validateAddVehicleSizeForm() {
      let validate_new = true;
      if (this.consobillLandingModel.portName == "") {
        $("#portName").focus();
        this.portNameError = "Enter Port Name";
        validate_new = false;
      }

      if (this.consobillLandingModel.portCode == "") {
        $("#portCode").focus();
        this.portCodeError = "Enter Port Code ";
        validate_new = false;
      }

      if (this.consobillLandingModel.portLocation == "") {
        $("#portLocation").focus();
        this.portLocationError = "Enter Port Location ";
        validate_new = false;
      }
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    validateVGM() {
      let validate_new = true;
      Object.keys(this.errorVgmList).map((x, index) => {
        if (this.consobillLandingModel[x] == "") {
          this.errorVgmList[x] = this.arrayErrorVgm[index];
          validate_new = false;
        }
      });

      if (
        this.consobillLandingModel.linerBLupload == "" &&
        this.consobillLandingModel.blType == "LinerBL"
      ) {
        this.errorlinerBLupload = "Upload B/L";

        validate_new = false;
      } else {
        this.errorlinerBLupload = "";
      }

      if (
        this.consobillLandingModel.linerBLNumber == "" &&
        this.consobillLandingModel.blType == "LinerBL"
      ) {
        this.errorlinerBLNumber = "Enter B/L Number";
        validate_new = false;
      } else {
        this.errorlinerBLNumber = "";
      }
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    addBLLanding() {
      this.consobillLandingModel["ffFclConsoExportId"] = this.$sessionsStorage.get(
        "editffFclConsoExportId"
      );
      this.consobillLandingModel["ffConExecutionId"] = this.$sessionsStorage.get(
        "editffConExecutionId"
      );
      this.consobillLandingModel["conFclBookingId"] = this.$sessionsStorage.get(
        "editffConExecutionId"
      );
      this.validateVGM();
      if (this.validate != false) {
        $("#addButtonLoaderCB").css("display", "none");
        $("#loaderCB").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addConsoFclBLLanding.php`,
          data: JSON.stringify(this.consobillLandingModel),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            $("#loaderCB").css("display", "none");
            $("#addButtonLoaderCB").css("display", "block");

            if (result.data.Id != "" && result.data.Id != undefined) {
              // window.location.reload(true);
              if (this.consobillLandingModel.conblLandingId != "") {
                this.alert.content = "Data updated Successfully";
              } else {
                this.alert.content = "Data Added Successfully";
              }

              Object.keys(this.consobillLandingModel).map((x) => {
                this.consobillLandingModel[x] = "";
              });
              this.getData();

              this.$refs["addPopBL"].open();
            }
          })
          .catch((error) => {});
      }
    },
    async addBLDateLanding() {
      this.consobillLandingModel["ffFclConsoExportId"] = this.$sessionsStorage.get(
        "editffFclConsoExportId"
      );

      let payload = {
        allModuleId: this.finalPlaceUSNONUS[0].allModuleId,
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        mbl_date: this.billLandingModel.mbl_date,
        mbl_release_date: this.billLandingModel.mbl_release_date,
        itemCode: "updateMBLDate",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getJobPendency.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { data, status, statusText } = result;
          if (status == 200 && data) {
          }
        })
        .catch((error) => {});
    },
    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this item?";
      this.$refs["addPop6"].open();
    },

    onClose(type) {},
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// conFclBLofLanding.vue?36349d0f